import withSizes from 'react-sizes'
import peg from 'src/pegTheme'

export default Component => {
  return withSizes(({ width }) => ({
    isMobile: width < parseFloat(peg.bp('mobile')),
  }))(Component)
}
